import _ from 'lodash'
import Vue from 'vue'

function filterMachineOwners(machineOwners, filterString, showFilter) {
  const subStrings = _.chain(filterString.toLowerCase()).split(' ').map(word => _.trim(word)).value()
  return _.filter(machineOwners, owner => {
    _.forEach(owner.machines, machine => {
      if((!filterString || _.every(subStrings, subString => _.includes(machine.searchText, subString))) &&
        (showFilter === 'all' || (machine.favourite && showFilter === 'fav') || (machine.createdByMe && showFilter === 'mine'))) {
        Vue.set(machine, 'display', true)
      } else {
        Vue.set(machine, 'display', false)
      }
    })
    const hasMachinesToDisplay = _.some(owner.machines, machine => machine.display)
    if((filterString || showFilter !== 'all') && hasMachinesToDisplay) {
      Vue.set(owner, 'expanded', true)
    } else if (owner.expanded) {
      Vue.set(owner, 'expanded', false)
    }
    return (showFilter !== 'all' && hasMachinesToDisplay) ||
      (showFilter === 'all' && (!filterString || hasMachinesToDisplay)) ||
      (filterString && _.every(subStrings, subString => _.includes(owner.searchText, subString)))
  })
}

function filterMachines(machines, filterString, showFilter) {
  const subStrings = _.chain(filterString.toLowerCase()).split(' ').map(word => _.trim(word)).value()
  return _.filter(machines, machine => (!filterString || _.every(subStrings, subString => _.includes(machine.searchText, subString))) &&
        (showFilter === 'all' || (machine.favourite && showFilter === 'fav') || (machine.createdByMe && showFilter === 'mine')))
}

export default {
  filterMachineOwners,
  filterMachines
}
